import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
//import { ALL_MEETINGS } from "../queries";
import { useQuery } from "@apollo/client";
import { FIND_SECTIONS_BY_MEETING } from "queries";
import bgImage from "assets/images/toimielimet.png";
import { FIND_MEETING_BY_ID } from "queries";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//ALL_ORGANS, ALL_COMMENTS, ALL_USERS, ALL_MINUT, ALL_MINUTES, ALL_LINKS, ALL_VOTES, ALL_INITIATIVES, ALL_MUNICIPALITIES, ALL_SECTIONS,  ORGAN_ADDED,  ALL_PROPOSALS
/* eslint-disable react/prop-types */
const Sections = ({ selectedKunta }) => {
  const [sections, setSections] = useState([]);
  //const [selected, setSelected] = useState([]);
  const [meet, setMeet] = useState({ organid: "Loading", meetingtext: "Loading" });
  ////console.log(setOrgans);

  let meeting = useParams().id;

  const sectionssw = useQuery(FIND_SECTIONS_BY_MEETING, {
    pollInterval: 100000,
    variables: { meeting },
  });
  const meetingsw = useQuery(FIND_MEETING_BY_ID, {
    pollInterval: 100000,
    variables: { id: meeting },
  });
  useEffect(() => {
    let sectionss = [];
    //let municipalitiess = [];
    if (sectionssw.data) {
      sectionss = sectionssw.data.findSectionsByMeeting;
      //setOrgans(organss);
      //console.log(sectionss);
      setSections(sectionss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [selectedKunta, sectionssw]);
  useEffect(() => {
    let meetingss = [];
    //let municipalitiess = [];
    //console.log(meetingsw);
    if (meetingsw.data) {
      meetingss = meetingsw.data.findMeetingById;
      //setOrgans(organss);
      //console.log(meetingss);
      setMeet(meetingss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [meetingsw]);
  const shareUrl = "https://kunta.live/agendas/" + meeting;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  if (sections.length > 0) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <div
          style={{
            left: "10px",
            position: "fixed",
            top: "90px",
            bottom: 0,
            height: "20px",
            color: "#C4DFE6",
            zIndex: 99,
            backgroundColor: "white",
            borderRadius: 90,
            opacity: 0.7,
          }}
          height="20px"
        >
          <div style={divstyle}>
            <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
              <FacebookIcon size={32} round />
            </FacebookShareButton>
          </div>
          <div style={divstyle}>
            <FacebookMessengerShareButton
              url={shareUrl}
              appId="521270401588372"
              className="Demo__some-network__share-button"
            >
              <FacebookMessengerIcon size={32} round />
            </FacebookMessengerShareButton>
          </div>
          <div style={divstyle}>
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <XIcon size={32} round />
            </TwitterShareButton>
          </div>
          <div style={divstyle}>
            <TelegramShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <TelegramIcon size={32} round />
            </TelegramShareButton>
          </div>
          <div style={divstyle}>
            <WhatsappShareButton
              url={shareUrl}
              title={title}
              separator=":: "
              className="Demo__some-network__share-button"
            >
              <WhatsappIcon size={32} round />
            </WhatsappShareButton>
          </div>
          <div style={divstyle}>
            <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
              <LinkedinIcon size={32} round />
            </LinkedinShareButton>
          </div>
          <div style={divstyle}>
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body="body"
              className="Demo__some-network__share-button"
            >
              <EmailIcon size={32} round />
            </EmailShareButton>
          </div>
          <div style={divstyle}>
            <InstapaperShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <InstapaperIcon size={32} round />
            </InstapaperShareButton>
          </div>
          <div style={divstyle}>
            <ThreadsShareButton
              url={shareUrl}
              title={title}
              className="Demo__some-network__share-button"
            >
              <ThreadsIcon size={32} round />
            </ThreadsShareButton>
          </div>
        </div>
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                {meet.organid + " " + meet.meetingtext}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Asiat</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {sections.map((p) => (
                        <TableRow
                          key={p.id}
                          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                        >
                          <TableCell component="th" scope="row">
                            <Link to={`/sections/${p.id}`}>{p.header}</Link>
                            {p.meetingtext} {p.organid}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return <li className="meeting">Ei Asioita</li>;
  }
};

export default Sections;
